import { getHighlightNotification, getNotifications, markNotificationsSeen } from '../../services/NotificationService'
import { isError } from '../../utils/api'

export default {
  state: {
    notifications: {
      notifications: null,
      totalCount: 0,
      pages: 0
    },
    highlight: {
      notifications: null,
      seen: false
    }
  },

  mutations: {
    hydrateNotifications(state, data) {
      if (state.notifications.notifications) {
        state.notifications.notifications = [...state.notifications.notifications, ...data.data]
      } else {
        state.notifications.notifications = data.data
      }
      state.notifications.totalCount = data.totalCount
      state.notifications.pages = data.pages
    },
    hydrateHighlightNotification(state, data) {
      state.highlight.notifications = data
    },
    markHighlightNotificationSeen(state) {
      state.highlight.seen = true
    },
    clearNotifications(state) {
      state.notifications.notifications = null
      state.notifications.totalCount = 0
    },
    clearHighlightNotification(state) {
      state.highlight.notifications = null
      state.highlight.seen = false
    }
  },

  actions: {
    async hydrateNotifications({ commit }, filters = {}) {
      const response = await getNotifications(filters).catch(e => e.response)
      const success = !isError(response.status)
      if (success) commit('hydrateNotifications', response.data)
      return success
    },
    async hydrateHighlightNotification({ commit }) {
      const response = await getHighlightNotification().catch(e => e.response)
      const success = !isError(response.status)
      if (success) commit('hydrateHighlightNotification', response.data)
      return success
    },
    async markNotificationsSeen() {
      const response = await markNotificationsSeen().catch(e => e.response)
      const success = !isError(response.status)
      return success
    },
    markHighlightNotificationSeen({ commit }) {
      commit('markHighlightNotificationSeen')
    },
    clearNotifications({ commit }) {
      commit('clearNotifications')
    },
    clearHighlightNotification({ commit }) {
      commit('clearHighlightNotification')
    }
  }
}
